import { useFormContext } from 'react-hook-form';
import { Button } from '@tremor/react';
import type { z as zod } from 'zod';
import { msg, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';

import { TextInput, Textarea, Select } from '@/components';
import type { contentBlockSchema } from '@/schemas';

export function ContentBlockForm({ onSave }: { readonly onSave: () => void }) {
  const { _ } = useLingui();
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<zod.infer<typeof contentBlockSchema>>();

  return (
    <div className='flex flex-col gap-4'>
      <TextInput
        name='title'
        label={_(msg`Title`)}
        placeholder={_(msg`Title`)}
        control={control}
        errorMessage={errors.title?.message}
      />
      <Textarea
        name='subtitle'
        label={_(msg`Subtitle`)}
        placeholder={_(msg`Subtitle`)}
        control={control}
        errorMessage={errors.subtitle?.message}
      />
      <Select
        name='published'
        label={_(msg`Published`)}
        control={control}
        options={[
          { label: _(msg`Yes`), value: 'true' },
          { label: _(msg`No`), value: 'false' },
        ]}
        value={watch('published') ? 'true' : 'false'}
        errorMessage={errors.published?.message}
        onChange={(value) => {
          setValue('published', (value as unknown as string) === 'true');
        }}
      />
      <div className='flex justify-end mb-4'>
        <Button onClick={onSave}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  );
}
